export default __webpack_public_path__ + "static/media/Privacy Policy for yekaterinazhmud.cdd86f9a.pdf";